export default (variable: string): string | undefined =>
  // eslint-disable-next-line no-underscore-dangle
  window._env && window._env[variable];
